import PropTypes from 'prop-types';
import React from 'react';
import BrandForm from './BrandForm';
import SimpleHeader from '../../../main/headers/simpleHeader';
import { getEmptyInitialValues } from '../helpers';

const AddBrand = ({ onSave }) => (
  <div>
    <SimpleHeader heading="Add brand" />
    <BrandForm
      onSave={onSave}
      cancelHref="/admin/brands"
      initialValues={getEmptyInitialValues()}
    />
  </div>
);

AddBrand.propTypes = {
  onSave: PropTypes.func.isRequired,
};

export default AddBrand;
